import { render, staticRenderFns } from "./mc-meal-wizard.vue?vue&type=template&id=6daad5d1&scoped=true"
import script from "./mc-meal-wizard.vue?vue&type=script&lang=ts"
export * from "./mc-meal-wizard.vue?vue&type=script&lang=ts"
import style0 from "./mc-meal-wizard.vue?vue&type=style&index=0&id=6daad5d1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6daad5d1",
  null
  
)

export default component.exports